
define('text!templates/modules/attachment/attachment-list-item.html',[],function () { return '<div class="ucolfix">\n    <span class="label label-primary active"><span class="filename">{{filename}}</span> &nbsp;<i class="fa fa-close remove-file"></i></span>\n</div>';});

